import { EventEmitter, Injectable, Output, Directive } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { GtErrorResponse } from '../models/GtErrorResponse';
import { UtilsService } from './utils';

type ErrorOrMessage = GtErrorResponse | string | Object;

@Directive()
@Injectable()
export class AlertService {
  @Output() action: EventEmitter<any> = new EventEmitter();
  public message$ = new Subject<any>();
  public challenge$ = new Subject<any>();
  public domain$ = new Subject<any>();

  constructor(private utils: UtilsService) {
  }

  public setMessage(msg: ErrorOrMessage) {
    if (this.utils.isEmpty(msg)) {
      return;
    }
    this.message$.next(msg);
  }

  public getMessageStream(): Observable<ErrorOrMessage> {
    return this.message$.asObservable();
  }

  public emitAction(): void {
    this.action.emit();
  }
}
